import React from "react";

export const STATUS_MAP = {
  ACTIVE: { label: "Active", variant: "success" },
  INACTIVE: { label: "Inactive", variant: "neutral" },
  TRASHED: { label: "Trashed", variant: "warning" },
  DELETED: { label: "Deleted", variant: "danger" },
  APPROVED: { label: "Approved", variant: "success" },
  PENDING: { label: "Pending", variant: "warning" },
  REJECTED: { label: "Disapproved", variant: "danger" },
  DISAPPROVED: { label: "Disapproved", variant: "danger" },
};

export function getStatusMeta(status) {
  const key = String(status ?? "").trim().toUpperCase();
  if (!key) return { label: "—", variant: "neutral" };
  return STATUS_MAP[key] || { label: String(status), variant: "neutral" };
}

export default function StatusBadge({ status, className = "" }) {
  const { label, variant } = getStatusMeta(status);
  return (
    <span className={`np-status-pill np-status-pill--${variant} ${className}`.trim()}>
      {label}
    </span>
  );
}
